import { render } from "./CreateCharacter.vue?vue&type=template&id=8b810afc&scoped=true"
import script from "./CreateCharacter.vue?vue&type=script&lang=js"
export * from "./CreateCharacter.vue?vue&type=script&lang=js"

import "./CreateCharacter.vue?vue&type=style&index=0&id=8b810afc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b810afc"]])

export default __exports__